const Data = [
    {
      id: 1,
      category: "education",
      icon: "icon-graduation",
      year: "2021 - Present",
      title: "Bachelors of Technology (B.Tech)",
      desc: "Pursuing B.Tech in Metallurgical and Materials Engineering from NIT Durgapur. CGPA - 8.09",
    },
    {
      id: 2,
      category: "education",
      icon: "icon-graduation",
      year: "2021",
      title: "AISSCE - CBSE 12th Boards",
      desc: "Stream - PCM, Marks - 84%, Cracked JEE Mains and WBJEE.",
    },
    {
      id: 3,
      category: "education",
      icon: "icon-graduation",
      year: "2019",
      title: "AISSE - CBSE 10th Boards",
      desc: "Marks - 93.6%",
    },
    {
      id: 4,
      category: "experience",
      icon: "icon-briefcase",
      year: "2021 - Present",
      title: "Web Development",
      desc: "Aspiring full-stack developer, learned skills in MERN stack, worked on several projects.",
    },
    {
      id: 5,
      category: "experience",
      icon: "icon-briefcase",
      year: "2023 - Present",
      title: "Data Analytics & Visualization",
      desc: "Worked with MS Excel, SQL and PowerBI to transform raw data into clean data and make dashboards.",
    },
    {
      id: 6,
      category: "experience",
      icon: "icon-briefcase",
      year: "2023 - Present",
      title: "Placement Coordinator",
      desc: "Working as a Placement Coordinator (Students Representative) in Training & Placement Cell, NIT Durgapur.",
    },
  ];

  export default Data;
  